import React from 'react'
import '../App.css';
import { FiCommand } from "react-icons/fi";
import { Transition } from 'react-transition-group';
import { sub } from 'date-fns';

export default function DonePage({inProp, failedToSubmit, submitResult, pastDeadline, applicationType, statusNotificationDate, acknowledgementEmailDate, parentReturnEmailDate, applicationStatusEmailDate}) {
    const duration = 700;
    const defaultStyle = {
    transition: `opacity ${duration}ms ease-in-out`,
    opacity: 0,
    }

    const transitionStyles = {
    entering: { opacity: 1 },
    entered:  { opacity: 1 },
    exiting:  { opacity: 0 },
    exited:  { opacity: 0 },
    };
    if((failedToSubmit || submitResult === null || submitResult === 0) && pastDeadline == false) {
        return (
            <>
            <Transition in={inProp} timeout={duration} appear>
                {state => (
                <div style={{
                    ...defaultStyle,
                    ...transitionStyles[state]
                }}>
                <h1 className='Title-settings'>ERROR</h1>
                <p>
                   Our appologies, a technical problem has occured and failed to submit the form. Please try again and if you still encouter the same issue, please contact <a href='mailto:programoptions@sd38.bc.ca'>programoptions@sd38.bc.ca</a>
                </p>
            </div>)}
            </Transition>
        </>   
        );
    } else if((failedToSubmit || submitResult === null || submitResult === 0) && pastDeadline == true) {
        return (
            <>
            <Transition in={inProp} timeout={duration} appear>
                {state => (
                <div style={{
                    ...defaultStyle,
                    ...transitionStyles[state]
                }}>
                <h1 className='Title-settings'>ERROR</h1>
                <p>
                The submission deadline has already passed, please contact <a href='mailto:programoptions@sd38.bc.ca'>programoptions@sd38.bc.ca</a>
                </p>
            </div>)}
            </Transition>
        </>   
        );
    }
    else {
        return (
            <>
            <Transition in={inProp} timeout={duration} appear>
                {state => (
                <div style={{
                    ...defaultStyle,
                    ...transitionStyles[state]
                }}>
                <h1 className='Title-settings'>Your application was submitted successfully!​</h1>

                <p>
                    Thank you for applying for SD38 District Program Options. Your application has been successfully submitted. Please carefully read the information below. You will also receive this information by email.
                </p>
                <p>
                    <br/><b>District Program Options Application ID: {submitResult} ({applicationType})</b>
                </p>
                <p>&nbsp;</p>
             
                <ul>
                    <li>
                        Please make sure you receive a confirmation email within the next 3 hours. If not, please contact <a href='mailto:programoptions@sd38.bc.ca'>programoptions@sd38.bc.ca</a>.
                    </li>
                    <li>
                        You will receive an email to acknowledge that your application has been received from the District Program Options office by {acknowledgementEmailDate}. If you do not receive this email, please contact <a href='mailto:programoptions@sd38.bc.ca'>programoptions@sd38.bc.ca</a>.
                    </li>
                    <li>
                        A draw for spaces in the district programs will be held in early February. Parents/Legal Guardians will receive an email on {statusNotificationDate} advising them of their status.
                    </li>
                    <li>
                        If you have not received an email by {parentReturnEmailDate}, please email <a href='mailto:programoptions@sd38.bc.ca'>programoptions@sd38.bc.ca</a>.
                    </li>
                    <li>
                        If you are offered a spot in the district program on {statusNotificationDate}, you will have until {applicationStatusEmailDate} to reply to the offer email to accept or decline the placement. If you do not respond by the deadline, you will be moved to the bottom of the waitlist.
                    </li>
                    <li>
                        If you accept a placement in a district program, your registration for your English/Neighbourhood catchment school will be cancelled. If you decide at any point in the future to withdraw from the district program, you will need to re-regsiter for your English/Neighbourhood catchment school and placement will be subject to available space at the time of registration.
                    </li>
                </ul>
              
                <p>&nbsp;</p>
                <p>
                    Sincerely,<br />District Program Options Team
                </p>
            </div>)}
            </Transition>
        </>   
        );
    }
}